import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useNavigate } from 'react-router-dom';

const ExportSection = ({ entriesCount }) => {
  const navigate = useNavigate();
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = () => {
    setIsExporting(true);
    setTimeout(() => {
      setIsExporting(false);
      navigate('/doctor-summary-export');
    }, 1000);
  };

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: 'MyBodyToday - Symptom History',
        text: 'View my symptom tracking history',
        url: window.location?.href
      })?.catch(() => {
        console.log('Share cancelled');
      });
    } else {
      const url = window.location?.href;
      navigator.clipboard?.writeText(url);
      alert('Link copied to clipboard!');
    }
  };

  return (
    <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-xl border border-border p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex-1">
          <h3 className="text-lg sm:text-xl font-heading font-semibold text-foreground mb-2">
            Ready for Your Doctor Visit?
          </h3>
          <p className="text-sm sm:text-base text-muted-foreground">
            Export your symptom history as a printable summary or share it with your healthcare provider.
          </p>
          <div className="flex items-center gap-2 mt-3">
            <Icon name="FileText" size={16} strokeWidth={2} className="text-primary" />
            <span className="text-sm font-medium text-foreground">
              {entriesCount} {entriesCount === 1 ? 'entry' : 'entries'} available
            </span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          <Button
            variant="outline"
            size="lg"
            onClick={handleShare}
            iconName="Share2"
            iconPosition="left"
            className="w-full sm:w-auto"
          >
            Share
          </Button>
          <Button
            variant="default"
            size="lg"
            onClick={handleExport}
            loading={isExporting}
            iconName="Download"
            iconPosition="left"
            className="w-full sm:w-auto"
          >
            Export Summary
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ExportSection;